import { ca } from '@cian/analytics';

export function trackFirstMessageSend(isShowPushCheckbox: boolean, isPushCheck: boolean) {
  if (isShowPushCheckbox) {
    const pushOnOff = isPushCheck ? 'PushOn' : 'PushOff';

    ca('event', {
      action: 'Send',
      category: 'subscription',
      label: `From_Chats/${pushOnOff}`,
      pagetype: 'Card',
    });
  }
}
